<p-toast />
<p-table
  #table
  [value]="users()"
  [columns]="cols"
  dataKey="id"
  [totalRecords]="totalRecords()"
  [rows]="10"
  [rowsPerPageOptions]="[10, 25, 50, 100]"
  [loading]="isLoading()"
  [paginator]="true"
  [scrollable]="true"
  scrollHeight="flex"
  [tableStyle]="{ 'min-width': '75rem' }"
  sortMode="multiple"
  editMode="row"
  [lazy]="true"
  (onLazyLoad)="loadData($event)"
  [globalFilterFields]="[
    'name',
    'company',
    'email',
    'roles',
    'firstName',
    'lastName',
  ]"
>
  <ng-template #caption>
    <div class="flex">
      <p-button
        label="Clear"
        [outlined]="true"
        icon="fa fa-filter-slash"
        (click)="clear(table)"
      />
      <p-iconfield iconPosition="left" class="ml-auto">
        <p-inputicon>
          <i class="pi pi-search"></i>
        </p-inputicon>
        <input
          pInputText
          type="text"
          (input)="onGlobalFilter(table, $event)"
          placeholder="Search keyword"
        />
      </p-iconfield>
    </div>
  </ng-template>
  <ng-template #header let-columns>
    <tr>
      <th class="button-column"></th>
      @for (column of columns; track $index) {
        <th [style]="column.style" [pSortableColumn]="column.sortField">
          <div class="flex items-center">
            {{ column.header | translate }}
            @if (column.filterField) {
              @switch (column.type) {
                @case ('text') {
                  <p-columnFilter
                    [type]="column.type"
                    [field]="column.filterField"
                    display="menu"
                    [maxConstraints]="1"
                    [matchModeOptions]="matchModes"
                    matchMode="contains"
                    [showOperator]="false"
                  />
                }
                @case ('tags') {
                  <p-columnFilter
                    type="text"
                    [field]="column.filterField"
                    display="menu"
                  />
                }
                @case ('boolean') {
                  <p-columnFilter
                    type="boolean"
                    [field]="column.filterField"
                    display="menu"
                  />
                }
              }
            }
            @if (column.sortField) {
              <p-sortIcon [field]="column.sortField" />
            }
          </div>
        </th>
      }
    </tr>
  </ng-template>
  <ng-template
    #body
    let-user
    let-columns="columns"
    let-editing="editing"
    let-ri="rowIndex"
  >
    <tr [pEditableRow]="user">
      <td class="button-column">
        <div class="flex items-center justify-center gap-2">
          @if (editing) {
            <p-button
              pRipple
              pSaveEditableRow
              icon="fa fa-check"
              (onClick)="onRowEditSave(user)"
              text
              rounded
              severity="secondary"
            ></p-button>
            <p-button
              pRipple
              pCancelEditableRow
              icon="fa fa-times"
              (onClick)="onRowEditCancel(user, ri)"
              text
              rounded
              severity="secondary"
            ></p-button>
          } @else {
            <p-button
              pRipple
              pInitEditableRow
              icon="fa fa-pencil"
              (onClick)="onRowEditInit(user)"
              text
              rounded
              severity="secondary"
            ></p-button>
            <p-menu
              #menu
              [model]="menuItems"
              [popup]="true"
              [appendTo]="table"
            />
            <p-button
              #menuButton
              pRipple
              (onClick)="menu.toggle($event)"
              icon="fa fa-ellipsis-v"
              text
              rounded
              severity="secondary"
            />
          }
        </div>
      </td>
      @for (column of columns; track $index) {
        @switch (column.type) {
          @case ('text') {
            <td>
              <p-cellEditor>
                <ng-template #input>
                  <input
                    pInputText
                    type="text"
                    [(ngModel)]="user[column.field]"
                    required
                  />
                </ng-template>
                <ng-template #output>
                  {{ user[column.field] }}
                </ng-template>
              </p-cellEditor>
            </td>
          }
          @case ('tags') {
            <td>
              <p-cellEditor>
                <ng-template #input>
                  <p-multiselect
                    [options]="column.textOptions || []"
                    [(ngModel)]="user[column.field]"
                    [placeholder]="
                      column.placeholder
                        ? (column.placeholder | translate)
                        : undefined
                    "
                    display="chip"
                    class="w-full @3xl:w-80"
                  />
                </ng-template>
                <ng-template #output>
                  <div class="w-full @3xl:w-80 flex">
                    @for (tag of user[column.field]; track $index) {
                      <p-tag
                        [value]="tag.toLowerCase()"
                        severity="success"
                        styleClass="m-1"
                      />
                    }
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>
          }
          @case ('boolean') {
            <td class="text-center">
              <p-cellEditor>
                <ng-template #input>
                  <p-toggleswitch [(ngModel)]="user[column.field]" />
                </ng-template>
                <ng-template #output>
                  <i
                    class="text-2xl fa"
                    [ngClass]="{
                      'text-lime-500 fa-check-circle': user[column.field],
                      'text-red-500 fa-times-circle': !user[column.field],
                    }"
                  ></i>
                </ng-template>
              </p-cellEditor>
            </td>
          }
        }
      }
    </tr>
  </ng-template>
  <ng-template #emptymessage>
    <tr>
      <td colspan="9">{{ 'message.noUserData' | translate }}</td>
    </tr>
  </ng-template>
</p-table>

<!-- <p-table
  #table
  [value]="users"
  dataKey="id"
  [rows]="10"
  [loading]="loading()"
  [rowHover]="true"
  [showGridlines]="true"
  [paginator]="true"
  [globalFilterFields]="filterFields"
  responsiveLayout="scroll"
>
  <ng-template #caption>
    <div class="flex justify-between items-center flex-column @xl:flex-row">
      <p-button
        label="Clear"
        class="p-button-outlined mb-2"
        icon="pi pi-filter-slash"
        (click)="clear(table)"
      ></p-button>
      <p-iconfield iconPosition="left" class="ml-auto">
        <p-inputicon>
          <i class="pi pi-search"></i>
        </p-inputicon>
        <input
          pInputText
          type="text"
          (input)="onGlobalFilter(table, $event)"
          placeholder="Search keyword"
        />
      </p-iconfield>
    </div>
  </ng-template>
  <ng-template #header>
    <tr>
      <th style="min-width: 12rem">
        <div class="flex justify-between items-center">
          Name
          <p-columnFilter
            type="text"
            field="name"
            display="menu"
            placeholder="Search by name"
          ></p-columnFilter>
        </div>
      </th>
      <th style="min-width: 12rem">
        <div class="flex justify-between items-center">
          Country
          <p-columnFilter
            type="text"
            field="country.name"
            display="menu"
            placeholder="Search by country"
          ></p-columnFilter>
        </div>
      </th>
      <th style="min-width: 14rem">
        <div class="flex justify-between items-center">
          Agent
          <p-columnFilter
            field="representative"
            matchMode="in"
            display="menu"
            [showMatchModes]="false"
            [showOperator]="false"
            [showAddButton]="false"
          >
            <ng-template #header>
              <div class="px-3 pt-3 pb-0">
                <span class="font-bold">Agent Picker</span>
              </div>
            </ng-template>
            <ng-template #filter let-value let-filter="filterCallback">
              <p-multiselect
                [ngModel]="value"
                [options]="representatives"
                placeholder="Any"
                (onChange)="filter($event.value)"
                optionLabel="name"
                styleClass="w-full"
              >
                <ng-template let-option #item>
                  <div class="flex items-center gap-2 w-44">
                    <img
                      [alt]="option.label"
                      src="https://primefaces.org/cdn/primeng/images/demo/avatar/{{
                        option.image
                      }}"
                      width="32"
                    />
                    <span>{{ option.name }}</span>
                  </div>
                </ng-template>
              </p-multiselect>
            </ng-template>
          </p-columnFilter>
        </div>
      </th>
      <th style="min-width: 10rem">
        <div class="flex justify-between items-center">
          Date
          <p-columnFilter
            type="date"
            field="date"
            display="menu"
            placeholder="mm/dd/yyyy"
          ></p-columnFilter>
        </div>
      </th>
      <th style="min-width: 10rem">
        <div class="flex justify-between items-center">
          Balance
          <p-columnFilter
            type="numeric"
            field="balance"
            display="menu"
            currency="USD"
          ></p-columnFilter>
        </div>
      </th>
      <th style="min-width: 12rem">
        <div class="flex justify-between items-center">
          Status
          <p-columnFilter field="status" matchMode="equals" display="menu">
            <ng-template #filter let-value let-filter="filterCallback">
              <p-select
                [ngModel]="value"
                [options]="statuses"
                (onChange)="filter($event.value)"
                placeholder="Any"
                [style]="{ 'min-width': '12rem' }"
              >
                <ng-template let-option #item>
                  <span [class]="'customer-badge status-' + option.value">{{
                    option.label
                  }}</span>
                </ng-template>
              </p-select>
            </ng-template>
          </p-columnFilter>
        </div>
      </th>
      <th style="min-width: 12rem">
        <div class="flex justify-between items-center">
          Activity
          <p-columnFilter
            field="activity"
            matchMode="between"
            display="menu"
            [showMatchModes]="false"
            [showOperator]="false"
            [showAddButton]="false"
          >
            <ng-template #filter let-filter="filterCallback">
              <p-slider
                [ngModel]="activityValues"
                [range]="true"
                (onSlideEnd)="filter($event.values)"
                styleClass="m-3"
                [style]="{ 'min-width': '12rem' }"
              ></p-slider>
              <div class="flex items-center justify-between px-2">
                <span>{{ activityValues[0] }}</span>
                <span>{{ activityValues[1] }}</span>
              </div>
            </ng-template>
          </p-columnFilter>
        </div>
      </th>
      <th style="min-width: 8rem">
        <div class="flex justify-between items-center">
          Verified
          <p-columnFilter
            type="boolean"
            field="verified"
            display="menu"
          ></p-columnFilter>
        </div>
      </th>
    </tr>
  </ng-template>
  <ng-template #body let-customer>
    <tr>
      <td>
        {{ customer.name }}
      </td>
      <td>
        <div class="flex items-center gap-2">
          <img
            src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
            [class]="'flag flag-' + customer.country.code"
            width="30"
            alt=""
          />
          <span>{{ customer.country.name }}</span>
        </div>
      </td>
      <td>
        <div class="flex items-center gap-2">
          <img
            [alt]="customer.representative.name"
            src="https://primefaces.org/cdn/primeng/images/demo/avatar/{{
              customer.representative.image
            }}"
            width="32"
            style="vertical-align: middle"
          />
          <span class="image-text">{{ customer.representative.name }}</span>
        </div>
      </td>
      <td>
        {{ customer.date | date: 'MM/dd/yyyy' }}
      </td>
      <td>
        {{ customer.balance | currency: 'USD' : 'symbol' }}
      </td>
      <td>
        <p-tag
          [value]="customer.status.toLowerCase()"
          [severity]="getSeverity(customer.status.toLowerCase())"
          styleClass="dark:bg-surface-900!"
        />
      </td>
      <td>
        <p-progressbar
          [value]="customer.activity"
          [showValue]="false"
          [style]="{ height: '0.5rem' }"
        />
      </td>
      <td class="text-center">
        <p-tag
          [value]="customer.status.toLowerCase()"
          [severity]="getSeverity(customer.status.toLowerCase())"
          styleClass="dark:bg-surface-900!"
        />
      </td>
    </tr>
  </ng-template>
  <ng-template #emptymessage>
    <tr>
      <td colspan="8">No customers found.</td>
    </tr>
  </ng-template>
  <ng-template #loadingbody>
    <tr>
      <td colspan="8">Loading customers data. Please wait.</td>
    </tr>
  </ng-template>
</p-table> -->

<!-- <p-table
  [value]="users"
  dataKey="id"
  editMode="row"
  [rows]="10"
  [loading]="loading()"
  [rowHover]="true"
  [showGridlines]="true"
  [paginator]="true"
  [globalFilterFields]="filterFields"
  responsiveLayout="scroll"
  [tableStyle]="{ 'min-width': '50rem' }"
>
  <ng-template #header>
    <tr>
      <th style="width: 20%">Code</th>
      <th style="width: 20%">Name</th>
      <th style="width: 20%">Inventory Status</th>
      <th style="width: 20%">Price</th>
      <th style="width: 20%"></th>
    </tr>
  </ng-template>
  <ng-template #body let-product let-editing="editing" let-ri="rowIndex">
    <tr [pEditableRow]="product">
      <td>
        <p-cellEditor>
          <ng-template #input>
            <input pInputText type="text" [(ngModel)]="product.code" />
          </ng-template>
          <ng-template #output>
            {{ product.code }}
          </ng-template>
        </p-cellEditor>
      </td>
      <td>
        <p-cellEditor>
          <ng-template #input>
            <input pInputText type="text" [(ngModel)]="product.name" required />
          </ng-template>
          <ng-template #output>
            {{ product.name }}
          </ng-template>
        </p-cellEditor>
      </td>
      <td>
        <p-cellEditor>
          <ng-template #input>
            <p-select
              [options]="[
                { label: 'In Stock', value: 'INSTOCK' },
                { label: 'Low Stock', value: 'LOWSTOCK' },
                { label: 'Out of Stock', value: 'OUTOFSTOCK' },
              ]"
              appendTo="body"
              [(ngModel)]="product.inventoryStatus"
              [style]="{ width: '100%' }"
            />
          </ng-template>
          <ng-template #output>
            <p-tag
              [value]="product.inventoryStatus"
              [severity]="getSeverity(product.inventoryStatus)"
            />
          </ng-template>
        </p-cellEditor>
      </td>
      <td>
        <p-cellEditor>
          <ng-template #input>
            <input pInputText type="text" [(ngModel)]="product.price" />
          </ng-template>
          <ng-template #output>
            {{ product.price | currency: 'EUR' }}
          </ng-template>
        </p-cellEditor>
      </td>
      <td>
        <div class="flex items-center justify-center gap-2">
          @if (!editing) {
            <p-button
              pRipple
              pInitEditableRow
              icon="fa fa-pencil"
              (click)="onRowEditInit(product)"
              text
              rounded
              severity="secondary"
            ></p-button>
          } @else {
            <p-button
              pRipple
              pSaveEditableRow
              icon="fa fa-check"
              (click)="onRowEditSave(product)"
              text
              rounded
              severity="secondary"
            ></p-button>
            <p-button
              pRipple
              pCancelEditableRow
              icon="fa fa-times"
              (click)="onRowEditCancel(product, ri)"
              text
              rounded
              severity="secondary"
            ></p-button>
          }
        </div>
      </td>
    </tr>
  </ng-template>
</p-table> -->
